import { Link } from "gatsby"
import React from "react"

import styles from "./LargeNumbers.module.scss"

const LargeNumbers = ({ number, text, url, external }) => {
  return url ? (
    external ? (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={url}
        className={`${styles.element} ${styles.link}`}
      >
        <strong>{number}</strong>
        <span>{text}</span>
      </a>
    ) : (
      <Link to={url} className={`${styles.element} ${styles.link}`}>
        <strong>{number}</strong>
        <span>{text}</span>
      </Link>
    )
  ) : (
    <div className={styles.element}>
      <strong>{number}</strong>
      <span>{text}</span>
    </div>
  )
}

export default LargeNumbers
